/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block;position:relative;overflow:hidden}[_nghost-%COMP%]     caroo-activity-indicator{position:absolute;right:6.25%;bottom:6.25%;width:18.75%;height:18.75%;z-index:1}caroo-resource[_ngcontent-%COMP%]{width:100%;height:100%;border-radius:1000px}caroo-resource[_ngcontent-%COMP%]     img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}"];
export { styles as styles };
